import type { MouseEventHandler } from 'react'
import React, { useState } from 'react'

import { Dropdown, Icon, LogoImage, Popper } from '@fourthwall/components'
import { DotsHorizontalIcon, NewWindowIcon } from '@fourthwall/icons'

import * as S from './ShopItem.styled'

export type ShopItemProps = {
  adminLink: string
  shopLink: string
  label: string
  labelDescription: string
  logoUrl?: string
}

export const ShopItem = ({
  adminLink,
  shopLink,
  logoUrl,
  label,
  labelDescription,
}: ShopItemProps) => {
  const [isOpen, setOpen] = useState(false)

  const toggleOpen = () => {
    setOpen((prevIsOpen) => !prevIsOpen)
  }

  const handleContainerMouseLeave = () => {
    setOpen(false)
  }

  const handleDotsButtonClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    toggleOpen()
  }

  const renderDots = () => (
    <Popper
      isOpen={isOpen}
      referenceComponent={
        <S.DotsButton
          type="button"
          onClick={handleDotsButtonClick}
          data-testid="ShopItem.DotsButton"
        >
          <Icon component={DotsHorizontalIcon} height={14} />
        </S.DotsButton>
      }
      popperProps={{
        placement: 'bottom-end',
        modifiers: [{ name: 'offset', options: { offset: [0, 5] } }],
      }}
      onClose={() => {
        setOpen(false)
      }}
    >
      <S.DropdownContainer>
        <Dropdown.Item label="Manage" href={adminLink} />
        <Dropdown.Item
          label={
            <S.ViewLabelInner>
              View <Icon component={NewWindowIcon} height={12} />
            </S.ViewLabelInner>
          }
          href={shopLink}
          target="_blank"
          onClick={toggleOpen}
        />
      </S.DropdownContainer>
    </Popper>
  )

  return (
    <S.Container href={adminLink} onMouseLeave={handleContainerMouseLeave}>
      <S.ItemContainer>
        <S.ImageContainer>
          <LogoImage
            logo={logoUrl}
            logoBackground={`${shopLink}/platform/theme/background.png`}
            placeholder={label.charAt(0)}
            size="small"
          />
        </S.ImageContainer>
        <S.LabelContainer>
          <S.Label>{label}</S.Label>
          <S.LabelDescription title={labelDescription}>{labelDescription}</S.LabelDescription>
        </S.LabelContainer>
      </S.ItemContainer>
      {renderDots()}
    </S.Container>
  )
}
